export enum SimWrapperError {
  InvalidBrowser = 'invalidBrowser',
  InvalidPlatform = 'invalidPlatform',
}
